import { Box, Grid, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { breadcrumbs, levels } from "./index.styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const Breadcrumb = () => {
  const location = useLocation();
  let currentLink = "";
  const arrow = (crumb: string) => {
    const formattedValue =
      crumb &&
      crumb
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Typography>{formattedValue}</Typography>
        <ChevronRightIcon sx={{ marginLeft: "15px" }} />
      </Box>
    );
  };
  const crumbsMaking = location.pathname
    .split("/")
    .filter((item) => item !== "")
    .map((crumb, index) => {
      currentLink = currentLink + `/${crumb}`;
      return (
        <Grid
          item
          key={index}
          sx={{
            marginLeft: "20px",
            marginBottom: "16px",
          }}
        >
          <Link
            to={currentLink}
            style={{
              ...levels,
              display: "flex",
              flexDirection: "row",
            }}
          >
            {arrow(crumb)}
          </Link>
        </Grid>
      );
    });
  return (
    <Box sx={{ ...breadcrumbs }}>
      <Grid container>{crumbsMaking}</Grid>
    </Box>
  );
};

export default Breadcrumb;
